import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useRef, useState } from 'react';
import HeadingSEO from '../../Utils/SEO/DescriptionSEO';
import { HeadTitle } from '../../Utils/SEO/styled';
import { SizePopupStyle } from '../../Utils/redirections';
import MaternityChips from '../MaternityWear/Chips';
import MaternitySizePopup from '../MaternityWear/MaternitySizePopup';
import SubCategoryContainer from '../MaternityWear/SubCategoryContainer';
import {
  closeSizeModal,
  highlightOnScroll,
  initialValue,
  popupBackHandler,
} from '../MaternityWear/utils';
import CategoryBanner from './CategoryBanner';
import CategoryFilter from './CategoryFilterAside/CategoryFilter';
import {
  FilterandProductGrid,
  MdContainer,
} from './CategoryFilterAside/styled';
import MobileCategories from './MobileScrollableCategories/MobileCategories';
import { StickyCategoryGrid } from './MobileScrollableCategories/styled';
import MoreCategoriesCover from './MoreCategoriesCover';
import { showNewCategoryUI } from './common';

const Modal = dynamic(() => import('react-modal'), {
  ssr: false,
});
const SubCategoryProducts = dynamic(() => import('./SubCategoryProducts'), {
  ssr: true,
});

export default function StickyCategoryGridCover(props) {
  const {
    tabsData,
    subCategoriesData,
    categoryNavBarData,
    categoryData,
    setAddedToCart,
    showPrice,
    showNewUI,
    categoryId,
    categoryName,
    bannerData,
    bottomRef,
    userType,
  } = props;

  const [activeElement, setActiveElement] = useState(-1);
  const [showSizePopup, setShowSizePopup] = useState(false);
  const [selectedProductId, setProductId] = useState(null);
  const [eventsData, setEventsData] = useState(initialValue);
  const [wrapHeight, setWrapHeight] = useState(130);
  const scrollRef = useRef();
  const chipsRef = useRef();

  const containerRef = useRef(null);
  const router = useRouter();
  const BottomPopup = SizePopupStyle('', '', '0', '50%');

  const tagStage = categoryData?.data?.tagStage;
  const categoryDescription =
    categoryData?.data?.categoryDescription ||
    categoryData?.data?.tabDescription ||
    categoryData?.data?.heroSectionBody;
  const heroSectionHeading = categoryData?.data?.heroSectionHeading;
  const _id = categoryId;
  let sideCategoryData = [];
  const [clicked, setClicked] = useState(false);

  const getSubCategories = (element) => {
    if (element?.subCategories?.length) {
      element?.subCategories?.map((item) => {
        if (item?.subCategories?.length) {
          getSubCategories(item);
        } else {
          if (_id === item?._id || _id === element?._id) {
            sideCategoryData = [...element?.subCategories];
          }
        }
      });
    } else {
      sideCategoryData = [...subCategoriesData];
    }

    return sideCategoryData;
  };
  const setFilterData = () => {
    sideCategoryData = [];
    let data = null;
    subCategoriesData?.map((element) => {
      data = getSubCategories(element);
    });
    return data;
  };

  const sideBarCategories = useMemo(() => {
    const data = setFilterData();
    data?.find((item, i) => {
      if (item._id === _id) {
        data[i]['isSelected'] = true;
        return true;
      }
    });
    return data;
  }, [_id]);

  const closeModal = () => {
    closeSizeModal(
      setShowSizePopup,
      router,
      eventsData.productName,
      selectedProductId,
    );
  };
  const callHighlightOnScroll = () => {
    highlightOnScroll(containerRef, chipsRef, false, bottomRef, wrapHeight);
  };

  useEffect(() => {
    if (showNewCategoryUI(showNewUI, categoryId)) {
      // const url = window.location.pathname;
      router.beforePopState(() => {
        popupBackHandler(setShowSizePopup);
        return true;
      });
      window.addEventListener('scroll', callHighlightOnScroll);
    }

    return () => {
      window.removeEventListener('scroll', callHighlightOnScroll);
      setActiveElement(-1);
      setWrapHeight(130);
    };
  }, [categoryId]);

  return (
    <StickyCategoryGrid
      gridTemplate={sideBarCategories?.length > 0 ? '84px 1fr' : '1fr'}
    >
      {showSizePopup ? (
        <Modal
          isOpen={showSizePopup}
          onRequestClose={closeModal}
          style={BottomPopup}
        >
          <MaternitySizePopup
            selectedProduct={selectedProductId}
            closePopup={closeModal}
            data={tabsData}
            setProductId={setProductId}
            setAddedToCart={setAddedToCart}
            eventsData={eventsData}
            sellingPrice={eventsData.sellingPrice}
            productName={eventsData.productName}
          />
        </Modal>
      ) : null}
      {sideBarCategories?.length > 0 && (
        <MobileCategories
          setClicked={setClicked}
          tabsData={sideBarCategories}
          _id={_id}
          clicked={clicked}
        />
      )}

      <FilterandProductGrid filter={subCategoriesData?.length}>
        <CategoryFilter
          selectedCategory={_id}
          categoryFilterData={subCategoriesData}
        />
        <MdContainer>
          <HeadTitle filter={subCategoriesData?.data?.length}>
            <HeadingSEO
              title={heroSectionHeading || categoryName}
              description={categoryDescription}
              maternity={true}
            />
          </HeadTitle>

          {showNewCategoryUI(showNewUI, categoryId) ? (
            <>
              {bannerData?.length > 0 && (
                <CategoryBanner
                  bannerData={bannerData}
                  category_name={categoryName}
                />
              )}

              <MaternityChips
                activeElement={activeElement}
                setActiveElement={setActiveElement}
                chips={tabsData}
                chipsRef={chipsRef}
                scrollRef={scrollRef}
                showHeader={false}
                wrapHeight={wrapHeight}
              />
              <SubCategoryContainer
                activeElement={activeElement}
                scrollRef={scrollRef}
                containerRef={containerRef}
                data={tabsData}
                setShowSizePopup={setShowSizePopup}
                setProductId={setProductId}
                setEventsData={setEventsData}
                setActiveElement={setActiveElement}
                showHeader={true}
                wrapHeight={wrapHeight}
                setWrapHeight={setWrapHeight}
                userType={userType}
                setAddedToCart={setAddedToCart}
                category_name={categoryName}
              />
            </>
          ) : (
            tabsData?.map((item, index) => (
              <SubCategoryProducts
                tabsData={tabsData}
                item={item}
                key={`subSection${categoryName + index}`}
                category_name={categoryName}
                setAddedToCart={setAddedToCart}
                showPrice={showPrice}
                index={index}
                tagStage={tagStage}
                isCategoryPage={true}
                clicked={clicked}
                userType={userType}
                outerIndex={index}
              />
            ))
          )}

          <MoreCategoriesCover
            bottomRef={bottomRef}
            categoryNavBarData={categoryNavBarData}
            subCategoriesData={subCategoriesData}
          />
        </MdContainer>
      </FilterandProductGrid>
    </StickyCategoryGrid>
  );
}
